// Serializable answers for the two-step wizard. The session store owns these
// drafts, so going back or restoring an account does not run another prompt tool.
export const WIZARD_QUESTIONS_PER_STEP = 2;
export const MAX_WIZARD_SELECTIONS = 6;

export function emptyWizardAnswer() {
  return { selectedOptions: [], customInput: '', skipped: false };
}

export function wizardAnswerValues(answer) {
  const custom = answer.customInput.trim();
  return custom ? [custom] : answer.selectedOptions;
}

export function wizardAnswerReady(answer) {
  return Boolean(answer.skipped || wizardAnswerValues(answer).length);
}

export function collectWizardFields(questions, answers) {
  return questions.flatMap((question, index) => {
    const values = wizardAnswerValues(answers[index]);
    return values.length ? [{ name: question.fieldName, pillar: question.pillar,
      values: [...values], isFaceted: values.length > 1 }] : [];
  });
}
